import { TranslationWaterAdditionByTravelMessages } from "../interfaces/waterAdditionByTravelMessages";

const waterAdditionByTravelMessages: TranslationWaterAdditionByTravelMessages = {
  "waterAdditionByTravel.title": "Water Addition by Travel",
  "waterAdditionByTravel.waterAdditionByTravel": "Water Addition by Travel",
  "waterAdditionByTravel.filterTitle": "Filter Water Additions by Travel",
  "waterAdditionByTravel.fleetCode": "Fleet",
  "waterAdditionByTravel.licensePlate": "Plate",
  "waterAdditionByTravel.startDate": "Start Date",
  "waterAdditionByTravel.finishDate": "End Date",
  "waterAdditionByTravel.driver": "Driver",
  "waterAdditionByTravel.document": "Doc.",
  "waterAdditionByTravel.volume": "Volume",
  "waterAdditionByTravel.reassignedPostDischarge": "Post-discharge (previous travel)",
  "waterAdditionByTravel.originTravelDoc": "Origin travel doc.",
  "waterAdditionByTravel.preDischarge": "Pre-discharge (L)",
  "waterAdditionByTravel.postDischarge": "Post-discharge (L)",
  "waterAdditionByTravel.noDataFound": "No water additions found for the selected period",
  "waterAdditionByTravel.minWater": "Min Water",
  "waterAdditionByTravel.maxWater": "Max Water",
  "waterAdditionByTravel.waterTotal": "Total Water (L)",
  "waterAdditionByTravel.waterAdditionTitle": "Water Addition",
  "waterAdditionByTravel.analyticTabTitle": "Analytic",
  "waterAdditionByTravel.syntheticTabTitle": "Synthetic"
};

export const messages = waterAdditionByTravelMessages;
